module.exports = __webpack_public_path__ + "static/pesvnouzi-913073f41c47c98ad9feed6dcfb4ae75.jpg";